import axios from "axios";
import CryptoJS from "crypto-js";
import { getToken } from "../common/LocalStorageService";
import { logOutRedirectCall } from "../common/RedirectPathManage";
import Globals from "../common/utils";

var key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_KEY);
var iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_IV);

const axiosClient = axios.create({
  baseURL: Globals.API_END_POINT,
  headers: {
    "api-key":bodyEncryption(process.env.REACT_APP_APP_NAME),
    "Accept-Language": "en",
    "Content-Type": "text/plain",
    type: "admin",
    platform_type: "W"
  },
});

// Body Encryption Request
axiosClient.interceptors.request.use(function (request) {
  request.data = bodyEncryption(request.data, true);
  const token = getToken();
  if (token) {
    request.headers["token"] = bodyEncryption(token);
  }
  return request;
});

axiosClient.interceptors.response.use(
  function (response) {
    response = bodyDecryption(response.data);

    // if (response.code === 400) {
    //   showErrorMessage(response.data.message);
    // }

    return response;
  },

  function (error) {
    let res = error.response;
    if (!error.response) {
      return Promise.reject(error);
    }

    if (res.status == 401) {
      logOutRedirectCall();
      const response = bodyDecryption(res.data);
      return response;
    } else if (
      res.status === 400 ||
      res.status === 409 ||
      res.status === 500 ||
      res.status === 404
    ) {
      const response = bodyDecryption(res.data);
      return response;
    } else {
      console.error(
        "Looks like there was a problem. Status Code: " + res.status
      );
      return Promise.reject(error);
    }
  }
);

function bodyEncryption(request, isStringify) {
  var request_ = isStringify ? JSON.stringify(request) : request;
  var encrypted = CryptoJS.AES.encrypt(request_, key, { iv: iv });
  return encrypted.toString();
}

function bodyDecryption(request) {
  var decrypted = CryptoJS.AES.decrypt(request.toString(), key, { iv: iv });

  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}

export { axiosClient };
